import React from "react";
import "./FounderPresident.css";
import founderImg from "../images/member1.jpg";
import presidentImg from "../images/member2.jpg";

const FounderPresident = () => {
  return (
    <div className="founder-president-container">

      {/* ================= FOUNDER ================= */}
      <section className="profile-section fade-in">
        <div className="profile-image">
          <img src={founderImg} alt="कै. रघुनाथ रामचंद्र बुरांडे" />
        </div>

        <div className="profile-content">
          <h2 className="profile-title">संस्थापक</h2>
          <h3 className="profile-name">कै. रघुनाथ रामचंद्र बुरांडे गुरुजी</h3>

          <p>
            कै. रघुनाथ रामचंद्र बुरांडे ग्रंथालय हे ज्ञान, अध्ययन आणि बौद्धिक विकासाचे एक समर्पित केंद्र असून दिनांक ०६ जानेवारी २००९ रोजी कोडोली, ता. पन्हाळा, जि. कोल्हापूर (महाराष्ट्र) येथे स्थापना करण्यात आली. या ग्रंथालयाची स्थापना श्री. मकरंद जगन्नाथ बुरांडे यांनी वाचनसंस्कृती, संशोधन व आजीवन शिक्षणाची आवड निर्माण करण्याच्या उद्देशाने केली.
          </p>

          <p>
            हे ग्रंथालय सर्व लागू शासकीय नियम, अटी व मानकांनुसार विकसित व व्यवस्थापित करण्यात आले आहे. ग्रंथालयास D दर्जाची मान्यता प्राप्त असून शैक्षणिक व प्रशासकीय निकषांचे पालन करण्यात येते. सीएसआर मार्गदर्शक तत्त्वांनुसार आवश्यक नोंदी व दस्तऐवज जतन केले जातात. पारदर्शकता व गुणवत्तावाढीसाठी दरवर्षी नियमित वार्षिक लेखापरीक्षण केले जाते.
          </p>

          <p>
            स्थापनेपासून आजपर्यंत हे ग्रंथालय विद्यार्थी, संशोधक व सर्वसामान्य वाचकांच्या शैक्षणिक गरजांसाठी सातत्याने विकसित होत आहे. पुस्तके, नियतकालिके, वृत्तपत्रे व डिजिटल साधनसामग्रीचा समृद्ध संग्रह येथे उपलब्ध असून शिक्षण, संशोधन व स्वअध्ययनास चालना मिळते.
          </p>

          <p>
            ग्रंथालयाची पायाभरणी ही त्यांच्या प्रेरणेतून झाली आहे. कोडोली गावातील संस्कृत विषयाचे आदरणीय शिक्षक म्हणून त्यांची ओळख होती. पुस्तकांवरील त्यांचे अतूट प्रेम व समाजात ज्ञानप्रसार करण्याची तळमळ ही त्यांच्या जीवनमूल्यांची ओळख होती.
          </p>
        </div>
      </section>


      {/* ================= PRESIDENT ================= */}
      <section className="profile-section fade-in delay">
        <div className="profile-image">
          <img src={presidentImg} alt="श्री. मकरंद जगन्नाथ बुरांडे" />
        </div>

        <div className="profile-content">
          <h2 className="profile-title">अध्यक्ष</h2>
          <h3 className="profile-name">ग्रंथालय अध्यक्ष श्री. मकरंद जगन्नाथ बुरांडे</h3>

          <p>
            हेच संस्कार व शैक्षणिक मूल्ये त्यांचे नातू श्री. मकरंद जगन्नाथ बुरांडे यांना लाभली. सामाजिक सेवेची आवड व आजोबांचे स्वप्न साकार करण्याच्या उद्देशाने ग्रंथालयाची स्थापना करण्यात आली. वाचनसंस्कृतीचा प्रसार, सांस्कृतिक मूल्यांचे जतन व बौद्धिक वारसा पुढे नेण्याच्या हेतूने या ग्रंथालयासाठी त्यांनी स्वतःच्या बचतीतून सुमारे २८ लाख रुपये इतकी मोठी रक्कम गुंतविली.
          </p>

          <p>
            आज तितक्याच तन्मयतेने हा वाचन चळवळीचा वारसा अध्यक्ष यांचे चिरंजीव ग्रंथालयाचे खजिनदार श्री ओंकार मकरंद बुरांडे हे करत असून ग्रंथालयाचे व्यवस्थापन ते स्वतः करत आहेत.
          </p>

          <p>
            या प्रकल्पाच्या सर्वांगीण विकासासाठी अनेक व्यक्ती व स्थानिक संस्थांनीही आपल्या क्षमतेनुसार सहकार्य केले आहे. त्यामुळेच आज या ग्रंथालयास स्वतःची स्वतंत्र इमारत व अभ्यासिका उपलब्ध आहे.
          </p>

          <p>
            भाड्याच्या छोट्या खोलीतून सुरू झालेला हा उपक्रम आज सुसज्ज, प्रशस्त आणि स्वतंत्र इमारतीत विकसित झाला आहे. सध्या ग्रंथालयाकडे ५०० पेक्षा अधिक सभासद असून १०,००० हून अधिक मौल्यवान पुस्तके वाचकांसाठी उपलब्ध आहेत.
          </p>

          <p>
            महाराष्ट्र शासनाकडून ‘डॉ. बाबासाहेब आंबेडकर उत्कृष्ट ग्रंथालय पुरस्कार’ मिळाल्याचा आम्हाला अभिमान आहे. ज्ञान, संस्कृती व सामाजिक सेवेचे प्रतीक म्हणून हे ग्रंथालय सातत्याने कार्यरत आहे.
          </p>
        </div>
      </section>

    </div>
  );
};

export default FounderPresident;